<template>
    <transition name="fade">
        <div class="withdraw">
            <template v-if="!success">
                <div class="container">
                    <Icon type="md-close" @click="close" size="18" class="cursor close-ico" />
                    <div class="title">{{type == 1 ? '支付' :'店铺'}}账户提现</div>
                    <div class="form-body">
                        <div class="body-tips">
                            <div class="icon-blue">i</div>
                            <div class="tips-text">
                                请确保下方银行卡的户名和卡号正确,如需修改,请前往<span @click="onShowCardInfo">修改绑卡信息</span>页面设置。
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-item-label">提现至</div>
                            <div class="form-item-content">
                                <div class="bank-info">
                                    <span>{{ bank_info.card_bank }}</span>
                                    <span>{{ bank_info.card_no }}</span>
                                    <span>{{ bank_info.card_name }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-item-label">提现金额</div>
                            <div class="form-item-content money">
                                <Input placeholder="请输入提现金额" v-model="form.money">
                                    <template #suffix>
                                        <div class="balance-input-suffix">元</div>
                                    </template>
                                </Input>
                                <div class="withdrawable-tips">
                                    <div class="withdrawable-text">可提现余额¥{{type == 1 ? shopInfo.available_withdraw_balance : shopInfo.shop_balance}}</div>
                                    <span @click="form.money=type == 1 ? shopInfo.available_withdraw_balance : shopInfo.shop_balance">全部提现</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-item-label">手机验证码</div>
                            <div class="form-item-content">
                                <Input placeholder="请输入手机验证码" v-model="form.code">
                                    <template #suffix>
                                        <sms-code :mobile="bank_info.card_mobile"></sms-code>
                                    </template>
                                </Input>
                                <div class="withdrawable-tips">
                                    <div class="withdrawable-text">请在当前账号绑定手机号 {{bank_info.card_mobile | phone_format}} 查看短信验证码</div>
                                </div>
                            </div>
                        </div>
                        <div class="form-btn-box">
                            <div class="btn cancel" @click="close">取消</div>
                            <div class="btn confirm" @click="onWithdraw">提现</div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="success-container">
                    <Icon type="md-close" @click="close" size="18" class="cursor close-ico" />
                    <img src="@/assets/images/icon-success-green.png" alt="" class="success-ico" />
                    <div class="main-text">已成功提交提现申请,提现中...</div>
                    <div class="sub-text">预计1-3个工作日内到账,具体到账时效以收款行处理时效为准。</div>
                    <div class="success-tips">
                        具体到账时间可至<span>提现记录</span>页面查看
                    </div>
                    <div class="btn" @click="close">确定</div>
                </div>
            </template>
        </div>
    </transition>
</template>
<script>
import { payApplyWithdraw, shopApplyWithdraw,GetUserBank } from '@/api';
import SmsCode from '@/components/SmsCode.vue';
import { mapState } from 'vuex';
export default{
    name:"Withdraw",
    props:{
        type:{
            type:[String,Number],
            default:1
        }
    },
    components:{SmsCode},
    computed:{
        ...mapState({
            shopInfo:state=>state.shopInfo
        })
    },
    data() {
        return {
            form:{
                money:'',
                code:''
            },
            success:false,
            bank_info:{}
        }
    },
    mounted(){
        this.$store.dispatch('getShopInfo');
        this.getUserBank()
    },
    methods:{
        onShowCardInfo(){
            this.$emit('show-card');
            this.close();
        },
        async getUserBank(){
            let { data } = await GetUserBank()
            if(data){
                this.bank_info = data
            }
        },
        async onShopWithdraw(){
            try{
                const {code,msg} = await shopApplyWithdraw(this.form);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.success = true;
                // this.$layer.msg('提现申请成功,请耐心等待审核');
                // this.$emit('close');
            }catch(e){
                console.log('err-withdraw',e);
                this.$layer.msg(e.msg);
            }
        },
        async onUserWithdraw(){
            try{
                const {code,msg} = await payApplyWithdraw(this.form);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.success = true;
                // this.$layer.msg('提现申请成功,请耐心等待审核');
                // this.$emit('close');
            }catch(e){
                console.log('err-withdraw',e);
                this.$layer.msg(e.msg);
            }
        },
        async onWithdraw(){
            if(this.form.money <= 0 || !this.form.money){
                this.$layer.msg('请输入提现金额');
                return;
            }
            if(!this.form.code){
                this.$layer.msg('请输入手机验证码');
                return;
            }
            if(this.type == 1){
                await this.onUserWithdraw();
            }else{
                await this.onShopWithdraw();
            }
            await this.$store.dispatch('getShopInfo');
        },
        close(){
            this.$emit('close');
        }
    }
}
</script>
<style lang="scss" scoped>
.withdraw{
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.5);
    display:flex;
    align-items:center;
    justify-content:center;
    position:fixed;
    top:0;
    left:0;
    z-index:119;
    .container{
        width:680px;
        background:#fff;
        border-radius:10px;
        display:flex;
        flex-direction:column;
        position:relative;
        .close-ico{
            position:absolute;
            top:14px;
            right:16px;
        }
        .title{
            width:100%;
            color:#0f1115;
            font-size:18px;
            font-weight:bold;
            padding-left:24px;
            padding-bottom:13px;
            padding-top:17px;
            border-bottom:1px solid #e0e0e0;
        }
        .form-body{
            width:100%;
            padding:12px 24px;
            .body-tips{
                width:100%;
                height:56px;
                display:flex;
                align-items:center;
                column-gap:8px;
                padding:18px 16px;
                background:#f7faff;
                .icon-blue{
                    width:20px;
                    height:20px;
                    text-align:center;
                    line-height:20px;
                    color:#fff;
                    background:#0d99ff;
                    border-radius:50%;
                }
                .tips-text{
                    color:#666;
                    font-size:14px;
                    span{
                        color:#0d99ff;
                        cursor:pointer;
                    }
                }
            }
            .form-item{
                display:flex;
                align-items:flex-start;
                column-gap:8px;
                margin-top:34px;
                .form-item-label{
                    color:#333;
                    font-size:14px;
                    text-align:right;
                    flex-shrink:0;
                    width:77px;
                    &::after{
                        content:"*";
                        color:red;
                    }
                }
                .form-item-content{
                    width:100%;
                    display:flex;
                    flex-direction:column;
                    color:#333;
                    .bank-info{
                        display:flex;
                        column-gap:14px;
                    }
                    .balance-input-suffix{
                        height:100%;
                        display:flex;
                        align-items:center;
                        justify-content:flex-end;
                        padding-right:10px;
                    }
                    .withdrawable-tips{
                        display:flex;
                        align-items:center;
                        column-gap:12px;
                        margin-top:10px;
                        .withdrawable-text{
                            color:#999;
                            font-size:14px;
                        }
                        span{
                            color:#0d99ff;
                            font-size:14px;
                            cursor:pointer;
                        }
                    }
                }
            }
            .form-btn-box{
                display:flex;
                align-items:center;
                column-gap:10px;
                justify-content:center;
                margin-top:64px;
                margin-bottom:48px;
                .btn{
                    width:100px;
                    height:40px;
                    border-radius:4px;
                    line-height:40px;
                    text-align:center;
                    cursor:pointer;
                    font-size:14px;
                    &.cancel{
                        border:1px solid #e3e3e3;
                        color:#666;
                    }
                    &.confirm{
                        background:#ff5967;
                        color:#fff;
                    }
                }
            }
        }
    }
    .success-container{
        width:500px;
        background:#fff;
        border-radius:10px;
        display:flex;
        flex-direction:column;
        align-items:center;
        position:relative;
        padding:40px 30px 30px 30px;
        .close-ico{
            position:absolute;
            top:14px;
            right:16px;
        }
        .success-ico{
            width:64px;
            height:64px;
        }
        .main-text{
            margin-top:22px;
            color:#0f1115;
            font-size:20px;
            font-weight:bold;
        }
        .sub-text{
            margin-top:10px;
            color:#666;
            font-size:14px;
        }
        .success-tips{
            margin-top:22px;
            width:100%;
            height:56px;
            background:#f7faff;
            line-height:56px;
            text-align:center;
            color:#666;
            font-size:14px;
            span{
                cursor:pointer;
                color:#0d99ff;
            }
        }
        .btn{
            width:100%;
            height:48px;
            line-height:48px;
            padding:0 10px;
            margin-top:36px;
            border-radius:4px;
            background:#ff5967;
            color:#fff;
            font-size:16px;
            font-weight:bold;
            text-align:center;
            cursor:pointer;
        }
    }
}

::v-deep .ivu-input-suffix{
    width:100px;
}

::v-deep .btn-code{
    color:#0d99ff;
}
</style>
